import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatResidentUserRepo, {
    CreateAuthorizeRequest,
    SetSeverSessionInfoRequest,
} from '../residentUser/repository/NatResidentUserRepo'
import NatTokenRepo from '../token/repository/NatTokenRepo'
import {NatGetRoomToResidentAuthenticationKey} from '../roomToResident/repository/NatGetRoomToResidentAuthenticationKey';
import {NatGetResidentUserAuthenticationKey} from '../residentUser/repository/NatGetResidentUserAuthenticationKey';
import {NatGetToken} from '../token/repository/NatGetToken';
import {FIRST_LOGIN_REFERRER_ID, HAVE_OR_NOT, RESIDENT_USER_TYPE} from '../../../CodeMaster';
import {getQueryParameter, NatAsyncCallFunction} from '../../common/util/Natutil';
import {HKConstants} from '../../../HKConstants';
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {
    CenterPlainLinkStyledButton,
    PrimaryStyledButton,
    SmallPlainLinkStyledButton,
} from '../../../styledComponents/Button'
import {TitleErrorLabel,} from '../../../styledComponents/DisplayItem'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {RequestItemError} from '../../../network/response/RequestItemError'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {OpenInNew, Phone} from '@mui/icons-material'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {Location} from 'react-router-dom'
import {SessionStorageHelper} from '../../../SessionStorageHelper';
import {NatSetServerSessionInfo} from '../residentUser/repository/NatSetServerSessionInfo';
import {NatCreateGenerateRequestParam} from '../residentUser/repository/NatCreateGenerateRequestParam';
import {NatCreateAuthorizeUrl} from '../residentUser/repository/NatCreateAuthorizeUrl';

const FIRSTLOGINLOCATIONSTATE = 'firstLoginLocationState'
const QUERYTOKEN = 'queryToken'
const KEY_SENI_URL = 'seniUrl'

interface FirstLoginLocationState {
    firstLoginReferrerId: string
    dIspStepInfo: DIspStepInfo
    policyAgreeType: string
    residentUserType: string
    authenticationKey: string
    firstLoginUserInfoInput: {
        hasekoId: string,
        parentResidentId: string,
        condominiumName: string,
        ridgeName: string,
        roomNumber: string,
        policyAgreeType: string,
        familyName: string,
        firstName: string,
        familyNameKana: string,
        firstNameKana: string,
        birthday: string,
        mailAddress: string,
        sex: string,
        accessControlDiv: string
    }
}

interface FieldsError {
    mailAddress: Error[]
    password: Error[]
}

type Field =
    'mailAddress'
    | 'password';

interface Error {
    message: string
    hasError: boolean
}

interface Props {
    residentUserRepo: NatResidentUserRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    tokenRepo: NatTokenRepo,
    location: Location<FirstLoginLocationState>
}

interface States {
    mailAddress: string,
    password: string,
    registerButtonFlg: boolean
    hasekoIdLoginButtonFlg: boolean
    errorSubUserExistMailAddressMessage: string
    errorTitleMessage: string
    isLoadCompleted: boolean
    flpExistFlag: string
    fieldsError: Partial<FieldsError>,
}

class NatResidentFirstLoginHasekoIdConfirmPage extends Component<Props & ResidentPagePropsSet, States> {
    firstLoginLocationState: FirstLoginLocationState
    queryToken: string

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)
        this.state = {
            mailAddress: '',
            password: '',
            registerButtonFlg: false,
            hasekoIdLoginButtonFlg: true,
            errorTitleMessage: '',
            errorSubUserExistMailAddressMessage: '',
            isLoadCompleted: false,
            flpExistFlag: HAVE_OR_NOT.NOT.value,
            fieldsError: {},
        }
        const locationState = this.props.location.state

        // @ts-ignore
        this.firstLoginLocationState = (locationState) ? locationState.firstLoginLocationState : []
        this.queryToken = getQueryParameter('token', this.props.location.search)

        if (!locationState) {
            window.location.href = `/resident/error`
            return
        }

        this.backLoginButtonClick = this.backLoginButtonClick.bind(this);
        this.hasekoIdLoginButtonClick = this.hasekoIdLoginButtonClick.bind(this);
        this.registerClick = this.registerClick.bind(this);
    }

    async componentDidMount(): Promise<void> {
        if (this.firstLoginLocationState.residentUserType === RESIDENT_USER_TYPE.SUB.value) {
            // サブユーザの場合
            await this.props.eventEmitter.showLoading()
            try {
                const tokenInfo: Nullable<NatGetToken> =
                    await NatAsyncCallFunction(
                        this.props.tokenRepo.getToken.bind(
                            this.props.tokenRepo, this.queryToken), this.props.navigate)
                if (tokenInfo && tokenInfo.details !== null) {
                    // フォームの初期値セット
                    this.setState({
                        mailAddress: (tokenInfo.details.flpExistFlag === HAVE_OR_NOT.HAVE.value) ?
                            tokenInfo.details.mailAddress : '',
                        registerButtonFlg: tokenInfo.details.flpExistFlag === HAVE_OR_NOT.HAVE.value,
                        flpExistFlag: tokenInfo.details.flpExistFlag,
                    })
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }
        this.setState({isLoadCompleted: true})
    }

    onClickAboutHasekoId(): void {
        window.open(HKConstants.CMN.OPC.ABOUT_HASEKO_ID_URL, '_blank')
    }

    onClickForgotPassword(): void {
        window.open(HKConstants.CMN.OPC.FLP_FORGET_PASSWORD_MAIL_URL, '_blank')
    }

    // 新規登録
    registerClick(): void {
        this.clearSubUserExistMailAddressMessage()
        let nextUrl: string = ''
        let step: DIspStepInfo = {}
        const residentUserType: string = this.firstLoginLocationState.residentUserType

        if (residentUserType === RESIDENT_USER_TYPE.MAIN.value) {
            // メインユーザの場合
            nextUrl = `/resident/firstLoginMailAddressRegister?token=${this.queryToken}`
            step = {
                policy: true,
                authenticationKey: true,
                hasekoIdConfirm: true,
                mailAddressRegister: true,
                mailReceive: true,
            }
        } else {
            // サブユーザの場合
            if (this.state.flpExistFlag === HAVE_OR_NOT.HAVE.value) {
                // 既に長谷工IDが登録されている場合
                const errorSubUserExistMailAddressMessage: string = 'ご入力のメールアドレスは既に長谷工IDに登録がされております<br/>'
                    + '「長谷工IDをお持ちの方」よりメールアドレス、パスワードの入力、ログインをお願い致します。<br/>'
                    + `パスワードをお忘れの方は<a href=${HKConstants.CMN.OPC.FLP_FORGET_PASSWORD_MAIL_URL} target="_blank">「ブランシエラクラブ＿パスワード再設定」</a>から再設定をお願い致します`
                this.setState({errorSubUserExistMailAddressMessage: errorSubUserExistMailAddressMessage})
                return
            } else {
                nextUrl = `/resident/firstLoginUserInfoInput?token=${this.queryToken}`
                step = {
                    policy: true,
                    hasekoIdConfirm: true,
                    subUserRegister: true,
                    subUserConfirm: true,
                    complete: true,
                }
            }
        }

        // 引継ぎ情報
        this.firstLoginLocationState.firstLoginReferrerId = FIRST_LOGIN_REFERRER_ID.HASEKO_ID_CONFIRM.value
        this.firstLoginLocationState.dIspStepInfo = step

        this.props.navigate(
            nextUrl,
            {state: {firstLoginLocationState: this.firstLoginLocationState}},
        )

    }

    // 長谷工IDログイン
    async hasekoIdLoginButtonClick(): Promise<void> {
        const isSutekiNetSmartPhoneApplication = SessionStorageHelper
            .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false');

        if (isSutekiNetSmartPhoneApplication === 'true') {
            const firstloginlocationstate = this.firstLoginLocationState
            const querytoken = this.queryToken
            setSessionStorage(FIRSTLOGINLOCATIONSTATE, JSON.stringify(firstloginlocationstate))
            setSessionStorage(QUERYTOKEN, querytoken)
            const setSeverSessionInfoRequestSp: SetSeverSessionInfoRequest = {
                authenticationKey: (this.firstLoginLocationState.authenticationKey) ?
                    this.firstLoginLocationState.authenticationKey : '',
                ssoLoginCondominiumCd: null,
                ssoLoginRidgeCd: null,
                ssoLoginRoomNumber: null,
                loginPage: null,
                token: querytoken,
                isSutekiNetSmartPhoneApplication: isSutekiNetSmartPhoneApplication
            };
            const ret: Nullable<NatSetServerSessionInfo> =
                await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                        this.props.residentUserRepo, setSeverSessionInfoRequestSp),
                    this.props.navigate
                );
            return;
        }

        await this.clearTitleErrorMessage();
        await this.clearMessage();

        await this.props.eventEmitter.showLoading();
        try {
            const firstloginlocationstate = this.firstLoginLocationState
            const querytoken = this.queryToken
            setSessionStorage(FIRSTLOGINLOCATIONSTATE, JSON.stringify(firstloginlocationstate))
            setSessionStorage(QUERYTOKEN, querytoken)
            const setSeverSessionInfoRequest: SetSeverSessionInfoRequest = {
                authenticationKey: (this.firstLoginLocationState.authenticationKey) ?
                    this.firstLoginLocationState.authenticationKey : '',
                ssoLoginCondominiumCd: null,
                ssoLoginRidgeCd: null,
                ssoLoginRoomNumber: null,
                loginPage: 'NatResidentFirstLoginHasekoIdConfirmPage',
                token: querytoken,
                isSutekiNetSmartPhoneApplication: null
            };
            const ret: Nullable<NatSetServerSessionInfo> =
                await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                        this.props.residentUserRepo, setSeverSessionInfoRequest),
                    this.props.navigate
                );
            if (ret) {
                // ログイン認証
                // ステート、ノンス取得し、セッションへ格納
                const createGenerateRequestParam: Nullable<NatCreateGenerateRequestParam> =
                    await NatAsyncCallFunction(
                        this.props.residentUserRepo.createGenerateRequestParam.bind(
                            this.props.residentUserRepo), this.props.navigate);

                if (createGenerateRequestParam) {
                    // パラメータ作成
                    const createAuthorizeRequest: CreateAuthorizeRequest = {
                        mailAddress: null,
                    };
                    const natCreateAuthorizeUrl: Nullable<NatCreateAuthorizeUrl> =
                        await NatAsyncCallFunction(
                            this.props.residentUserRepo.createAuthorize.bind(
                                this.props.residentUserRepo, createAuthorizeRequest), this.props.navigate);
                    if (natCreateAuthorizeUrl && natCreateAuthorizeUrl.details) {
                        const seniurl: string = getQueryParameter('seniurl', this.props.location.search);
                        if (seniurl) {
                            setSessionStorage(KEY_SENI_URL, seniurl);
                        }
                        window.location.href = natCreateAuthorizeUrl.details;
                    }
                }
            }
        } catch (HttpError) {
            // 認証エラー
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody;
            if (errorResponseBody !== null) {
                if (errorResponseBody.requestError !== null) {
                    this.setTitleErrorMessage(errorResponseBody.requestError.title);
                }
                errorResponseBody.requestItemErrors.forEach((item: RequestItemError) => {
                    if (item.fields) {
                        item.fields.forEach((field) => {
                            this.setFieldErrorMessage(field, item.message)
                        });
                    }
                });
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // ログインページへ
    backLoginButtonClick(): void {
        this.props.navigate(
            `/resident/login`,
        )
    }

    // メッセージ設定（タイトル）
    setTitleErrorMessage(message: string): void {
        this.setState({errorTitleMessage: message})
    }

    // メッセージ取得（タイトル）
    getTitleErrorMessage(): Nullable<ReactElement> {
        if (this.state.errorTitleMessage !== '') {
            return (
                <TitleErrorLabel>
                    {this.state.errorTitleMessage}
                </TitleErrorLabel>
            )
        } else {
            return null
        }
    }

    // メッセージ設定（フィールド）
    setFieldErrorMessage(field: string, message: string): void {
        if (field === 'mailAddress' || field === 'password') {
            let error: Error[] | undefined = this.state.fieldsError[field]
            if (error === undefined) {
                error = [{message: message, hasError: true}]
            } else {
                error.push({message: message, hasError: true})
            }

            this.setState(({fieldsError}) => (
                {
                    fieldsError: {
                        ...fieldsError,
                        [field]: error,
                    },
                }))
        }
    }

    // メッセージクリア
    clearMessage(): void {
        this.setState({
            errorTitleMessage: '',
            fieldsError: {},
        })
    }


    getErrorSubUserExistMailAddressMessage(): Nullable<ReactElement> {
        if (this.state.errorSubUserExistMailAddressMessage !== '') {
            return (
                <TitleErrorLabel>
                    <div dangerouslySetInnerHTML={{__html: this.state.errorSubUserExistMailAddressMessage}}/>
                </TitleErrorLabel>
            )
        } else {
            return null
        }
    }


    // メッセージクリア（タイトル）
    clearTitleErrorMessage(): void {
        this.setState({errorTitleMessage: '', errorSubUserExistMailAddressMessage: ''})
    }

    // メッセージクリア（タイトル）
    clearSubUserExistMailAddressMessage(): void {
        this.setState({errorTitleMessage: '', errorSubUserExistMailAddressMessage: ''})
    }


    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <NatStepComponent
                    dIspStepInfo={this.firstLoginLocationState.dIspStepInfo}
                    nowStep={Step.HASEKO_ID_CONFIRM}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        長谷工ID確認
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <MessageBlock>
                    {this.getErrorSubUserExistMailAddressMessage()}
                </MessageBlock>
                <WideMainContainer>
                    <BlockSpacer height={'15px'}/>
                    <Box fontWeight={FontWeights.Bold}>長谷工IDをお持ちでない方</Box>
                    <BlockSpacer height={'15px'}/>
                    <SmallPlainLinkStyledButton onClick={this.onClickAboutHasekoId}>
                        長谷工ID
                    </SmallPlainLinkStyledButton>
                    をお持ちでない方は、こちらから素敵ネットの新規登録にお進みください。
                    <br/>
                    登録後、自動で長谷工IDが発行されます。
                    <BlockSpacer height={'30px'}/>
                    <PrimaryStyledButton
                        onClick={this.registerClick}
                        disabled={this.state.registerButtonFlg}>
                        新規登録する
                    </PrimaryStyledButton>
                    <BlockSpacer height={'30px'}/>
                </WideMainContainer>
                <BlockSpacer height={'15px'}/>
                <WideMainContainer>
                    <BlockSpacer height={'15px'}/>
                    <Box fontWeight={FontWeights.Bold}>長谷工IDをお持ちの方</Box>
                    <BlockSpacer height={'15px'}/>
                    既に<SmallPlainLinkStyledButton onClick={this.onClickAboutHasekoId}>
                    長谷工ID
                </SmallPlainLinkStyledButton>
                    をお持ちの方は、長谷工IDを使用して素敵ネットにログインできます。
                    {this.getTitleErrorMessage()}
                    <BlockSpacer height={'30px'}/>
                    <PrimaryStyledButton
                        id={'loginIdBtn'}
                        onClick={this.hasekoIdLoginButtonClick}>
                        長谷工IDでログインする
                    </PrimaryStyledButton>
                    <BlockSpacer height={'30px'}/>
                </WideMainContainer>
                <BlockSpacer height={'30px'}/>
                <CenterPlainLinkStyledButton onClick={this.backLoginButtonClick}>
                    ログイン画面へ戻る
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'30px'}/>
                <LeftRowFlexContainer>
                    <Box width={'15px'}/>
                    <ContactArea>
                        <Box fontSize={FontSize.Middle}>操作に関するお問合せは下記までご連絡ください。</Box>
                        <Box height={'10px'}/>
                        <Box fontSize={FontSize.Middle}>{Messages.IRESR0001.toString('')}</Box>
                        <Box height={'5px'}/>
                        <LeftRowFlexContainer>
                            <PhoneIcon fontSize={'large'}/>
                            <Box width={'10px'}/>
                            <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                                {Messages.IRESR0002.toString()}
                            </Box>
                        </LeftRowFlexContainer>
                        <AlignItemsStartFlexContainer>
                            <Box>受付時間</Box>
                            <Box width={'10px'}/>
                            <Box>{Messages.IRESR0003.toString()}</Box>
                        </AlignItemsStartFlexContainer>
                    </ContactArea>
                </LeftRowFlexContainer>
            </>
        )
    }
}

export default createResidentPage(NatResidentFirstLoginHasekoIdConfirmPage)

// メッセージブロック
const MessageBlock: StyledDiv = styled.div`
  text-align: left;
`;
// お問い合わせ
const ContactArea: StyledDiv = styled.div`
  text-align: left;
`;
const AlignItemsStartFlexContainer = styled(LeftRowFlexContainer)`
    align-items: flex-start;
    font-Size: ${FontSize.Small};
`
// 電話アイコン
const PhoneIcon = withStyles({
    root: {
        color: Colors.Primary,
    },
})(Phone)

// アイコン
const StyledExternalUrlIcon = styled(OpenInNew)`
  margin-left: 5px;
  vertical-align: sub;
  width: 18px !important;
  height: 18px !important;
`;

function setSessionStorage(key: string, value: any | null): void {
    if (value) {
        SessionStorageHelper.setItem(key, value)
    } else {
        SessionStorageHelper.setItem(key, '')
    }
}
